import { render, staticRenderFns } from "./BadImagesView.vue?vue&type=template&id=04fd7962"
import script from "./BadImagesView.vue?vue&type=script&lang=js"
export * from "./BadImagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports